import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import ButtonApproval from "components/Buttons/ButtonApproval";
import ButtonNotes from "components/Buttons/ButtonNotes";
import ButtonReproval from "components/Buttons/ButtonReproval";
import * as React from "react";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps {
    onApproval: () => void;
    onReproval: () => void;
    onNotes: () => void;
    approvalText?: string;
    reprovalText?: string;
    notesText?: string;
}

type Props = IProps & StyledComponentProps<FeedClassKey>;

/////////////////////////////////////////////////////////////////////////////////////

class ApprovalButtons extends React.PureComponent<Props, IState> {

    render() {

        return (
            <div>
                <ButtonApproval onClick={() => this.props.onApproval()} text={this.props.approvalText} justIcon={false} size="small" />
                <ButtonReproval onClick={() => this.props.onReproval()} text={this.props.reprovalText} justIcon={false} size="small" />
                <ButtonNotes onClick={() => this.props.onNotes()} text={this.props.notesText} justIcon={false} size="small" />
            </div>
        );

    }

}

export default ApprovalButtons;
